/**
 * Extract date part from ISO string
 * @param {Date} date Input date
 * @returns {string} ISO date
 */
export default function (date) {
  return date.toISOString().slice(0, 10)
}
